import React from 'react';
import {
  Banners,
  OtherSections,
  ProductHighlight,
  Remembers,
  ReportsFeatures,
} from '#components/organisms';
import { features } from '#mocks/liquidations';
import { Layout } from '#hocs/layout';

const ReportsView = () => {
  const SECTION = 'reports';

  return (
    <Layout section={SECTION}>
      <ReportsFeatures
        data={features}
        copy="Las mejores funcionalidades"
        title="No sabías que lo necesitabas, hasta ahora"
        description="Descubre todo lo que esta sección tiene para ofrecerte, con formatos versátiles y compatibilidad en múltiples dispositivos."
      />
      <ProductHighlight section={SECTION} />
      <Remembers section={SECTION} />
      <OtherSections section={SECTION} />
      <Banners section={SECTION} />
    </Layout>
  );
};
export default ReportsView;
